import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import cx from "classnames";
import { Typography } from "@mui/material";

const MODAL_CLOSE_ICON =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzg4Nl8yNjk3IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSItMiIgeT0iLTIiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CjxyZWN0IHg9Ii0yIiB5PSItMiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRDlEOUQ5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF84ODZfMjY5NykiPgo8cGF0aCBkPSJNNC4zOTk5NSAxNy44MDAyTDIuMTk5OTUgMTUuNjAwMkw3Ljc5OTk1IDEwLjAwMDJMMi4xOTk5NSA0LjQwMDJMNC4zOTk5NSAyLjIwMDJMOS45OTk5NSA3LjgwMDJMMTUuNiAyLjIwMDJMMTcuOCA0LjQwMDJMMTIuMiAxMC4wMDAyTDE3LjggMTUuNjAwMkwxNS42IDE3LjgwMDJMOS45OTk5NSAxMi4yMDAyTDQuMzk5OTUgMTcuODAwMloiIGZpbGw9IiMxQzFCMUYiLz4KPC9nPgo8L3N2Zz4K";

const Modal = (props) => {
    const isControlled = typeof props.show == "boolean";
    const isShown = isControlled ? props.show : false;

    return (
        <div
            className={cx({ modal: true, show: isShown }, props.className)}
            id={props.modalId || "modal"}
            role="dialog"
            aria-labelledby="modalLabel"
            aria-hidden={isControlled ? (!isShown).toString() : "true"}
            data-backdrop="static"
            style={isControlled ? { display: isShown ? "block" : "none" } : undefined}
        >
            <div className="modal-dialog modal-default">
                <div className="modal-content">{props.children}</div>
            </div>
        </div>
    );
};

export const Modal2Base = (props) => {
    const {
        show,
        modalId,
        title,
        description,
        onClose,
        children,
        footerLeft,
        footerRight,
        className,
        bodyClassName,
        footerClassName,
    } = props;

    return (
        <Modal show={show} modalId={modalId}>
            <div className={cx("modal-base", "modal2-base", className)}>
                <div className="modal-header modal-base-header">
                    <div className="modal-base-head-row">
                        <div className="modal-base-head-copy">
                            <Typography className="MuiTypography-modaltitle" component="h2">
                                {title}
                            </Typography>
                        </div>
                        {onClose ? (
                            <button
                                type="button"
                                onClick={onClose}
                                className="modal-base-close"
                                aria-label="close"
                            >
                                <img
                                    src={MODAL_CLOSE_ICON}
                                    alt="close"
                                    style={{ width: 20, height: 20 }}
                                />
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className={cx("modal-body", bodyClassName)}>
                    {description ? (
                        <div className="modal-base-body-flow">
                            <div className="modal-base-description">{description}</div>
                            {children}
                        </div>
                    ) : (
                        children
                    )}
                </div>

                {(footerLeft || footerRight) && (
                    <div className={cx("modal-footer", footerClassName)}>
                        <div className="modal-base-footer">
                            <div className="modal-base-footer-left">{footerLeft || <span />}</div>
                            <div className="modal-base-footer-right">{footerRight}</div>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default Modal;
